import imagefilters from 'canvas-filters';

export function reduceDecimalPlaces(num, numDecimals = 0) {
  const pow10s = Math.pow(10, numDecimals);
  return numDecimals ? Math.round(pow10s * num) / pow10s : num;
}

export function getArrayAverage(imageArray, numDecimals = 0) {
  const width = imageArray[0].length;
  const height = imageArray.length;
  const arrSum = imageArray.flat().reduce((a, b) => a + b, 0);
  return reduceDecimalPlaces(arrSum / (width * height), numDecimals);
}

export function getArrayVariance(imageArray, numDecimals = 0) {
  const avg = getArrayAverage(imageArray, numDecimals);
  let variance = 0;
  for (let y = 0; y < imageArray.length; y++) {
    for (let x = 0; x < imageArray[0].length; x++) {
      variance += Math.pow(imageArray[y][x] - avg, 2);
    }
  }
  variance /= imageArray.length * imageArray[0].length;
  return reduceDecimalPlaces(variance, numDecimals);
}

// Convolve over the image with a laplacian kernel to detect edges.
export function detectEdges(imageData, context, canvas) {
  var grayImage;
  // first convert the image to grayscale
  grayImage = imagefilters.GrayScale(imageData);

  // now detect the edges using the Edge function,
  // which convolves over the image with a laplacian kernel
  return imagefilters.Edge(grayImage);
}

// Compute a blur score based on the imageData after the laplacian kernel
// has been applied. The blur score is determined by the variance of the
// image. If an image contains high variance then there is a wide spread
// of responses, both edge-like and non-edge like, representative of a
// normal, in-focus image. But if there is very low variance, then there
// is a tiny spread of responses, indicating there are very little edges
// in the image. The more an image is blurred, the less edges there are.
export function detectBlur(imageData, context, canvas) {
  // //////////////////////////////////////////////////////////////
  //   // THIS SECTION IS ONLY FOR VISUALIZING EDGES WHILE CODING /
  //   // context.putImageData(imageData,0,0);
  //   //
  //   // var debugImage = document.createElement('img');
  //   // debugImage.onload = function(){
  //   //   document.body.appendChild(debugImage);

  //   // }
  //   // debugImage.src= canvas.toDataURL();
  // /////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////

  var i,
    x,
    y,
    row,
    pixels = imageData.data,
    rowLen = imageData.width * 4,
    rows = [];

  // convert the image data into an Array
  for (y = 0; y < pixels.length; y += rowLen) {
    row = new Array(imageData.width);
    x = 0;
    for (i = y; i < y + rowLen; i += 4) {
      row[x] = pixels[i];
      x += 1;
    }
    rows.push(row);
  }
  var precision = 4; // number of decimals

  // now that it's converted to an array, we can calculate the variance
  return getArrayVariance(rows, precision);
}

export function blobToImage(blob) {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    const url = URL.createObjectURL(blob);
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = reject;
    img.src = url;
  });
}

export const getCroppedImgBlob = ({ image, crop }) => {
  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  canvas.width = crop.width * scaleX;
  canvas.height = crop.height * scaleY;

  const ctx = canvas.getContext('2d');
  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    canvas.width,
    canvas.height
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) reject(new Error('Canvas is empty'));
        else resolve(blob);
      },
      'image/jpeg',
      0.95
    );
  });
};

export const centerCrop = ({
  widthPercent = 100,
  heightPercent = 70,
  paddingPercent = 0
}) => {
  const cropWidth = widthPercent - paddingPercent;
  const cropHeight = heightPercent - paddingPercent;
  const x = (100 - cropWidth) / 2;
  const y = (100 - cropHeight - 10) / 2;

  return {
    unit: '%',
    x,
    y,
    width: cropWidth,
    height: cropHeight
  };
};
